module.exports = __webpack_public_path__ + "static/media/artificial-intelligence.1ce2d822.svg";